// Vue
import Vue from 'vue'

// Components
import {AbhAufUmbauarten} from './abh_auf_umbauarten/AbhAufUmbauarten'
import {AbhVerkaufteEinheiten} from './abh_verkaufte_einheiten/AbhVerkaufteEinheiten'
import {Autocomplete} from "./autocomplete/Autocomplete";
import {Breadcrumb} from './breadcrumb/Breadcrumb'
import {Button} from './button/Button'
import {ButtonLink} from './button_link/ButtonLink'
// import {Carousel} from './carousel/Carousel'
// import {CarouselItemImg} from './carousel/item_img/CarouselItemImg'
import {Calendar} from './calendar/Calendar'
import {Checkbox} from './checkbox/Checkbox'
import {CheckboxGroup} from './checkbox/group/CheckboxGroup'
import {Col} from './col/Col'
import {Communication} from './communication/Communication'
import {CommunicationModule} from './communication_module/CommunicationModule'
import {ContentArea} from './content_area/ContentArea'
import {Container} from './container/Container'
import {Cookie} from './cookie/Cookie'
import {FixedFooter} from './fixed_footer/FixedFooter'
import {Fold} from './fold/Fold'
import {FoldIf} from './fold_if/FoldIf'
import {Footer} from './footer/Footer'
import {Dropdown} from './dropdown/Dropdown'
import {Expander} from './expander/Expander'
import {FileInput} from './file_input/FileInput'
import {FilterBox} from './filter_box/FilterBox'
import {FilterItem} from './filter_box/filter_item/FilterItem'
import {FilterBar} from './filter_bar/FilterBar'
import {FilterBarItem} from './filter_bar/item/FilterBarItem'
import {Form} from './form/Form'
import {GltState} from './glt_state/GltState'
import {Groupbox} from './groupbox/Groupbox'
import {H} from './h/H'
import {HeadInfo} from './head_info/HeadInfo'
import {HeadInfoItem} from './head_info/item/HeadInfoItem'
import {Header} from './header/Header'
import {HeaderDefault} from './header_default/HeaderDefault'
import {DropdownOption} from './dropdown/option/DropdownOption'
import {Icon} from './icon/Icon'
import {Input} from './input/Input'
import {InputGroup} from './input_group/InputGroup'
import {InputList} from './input_list/InputList'
import {InputListMultiple} from './input_list_multiple/InputListMultiple'
import {Iris} from './iris/Iris'
import {LightboxImg} from './lightbox_img/LightboxImg'
import {Link} from './link/Link'
import {Loading} from './loading/Loading'
import {Message} from './message/Message'
import {Modal} from './modal/Modal'
import {ModalIframe} from './modal_iframe/ModalIframe'
import {NavigationBar} from './navigation_bar/NavigationBar'
import {NavigationBarItem} from './navigation_bar/item/NavigationBarItem'
import {P} from './p/P'
import {Pagination} from './pagination/Pagination'
import {PrivacyPolicy} from './privacy_policy/PrivacyPolicy'
import {ProcessBar} from './process_bar/ProcessBar'
import {ProcessBarStep} from './process_bar/step/ProcessBarStep'
import {ProgressBar} from './progress_bar/ProgressBar'
import {Radio} from './radio/Radio'
import {RadioGroup} from './radio/group/RadioGroup'
import {Repeater} from "./repeater/Repeater";
import {RichText} from "./rich_text/RichText";
import {Row} from './row/Row'
import {Select} from './select/Select'
import {SelectGroup} from './select/group/SelectGroup'
import {SelectOption} from './select/option/SelectOption'
import {Slider} from './slider/Slider'
import {SliderItemImg} from './slider/item_img/SliderItemImg'
import {Table} from './table/Table'
import {TableCol} from './table/col/TableCol'
import {Tab} from './tabs/tab/Tab'
import {Tabs} from './tabs/Tabs'
import {TechdocSelectList} from './techdoc_select_list/TechdocSelectList'
import {Textarea} from './textarea/Textarea'
import {Tile} from './tile/Tile'
import {TileGroup} from './tile/group/TileGroup'
import {Toggle} from './toggle/Toggle'
import {Tooltip} from './tooltip/Tooltip'

// Utils
import {registerComponents} from '../../utils/registerComponents'
import {HeaderFooterApplication} from "./header_footer_application/HeaderFooterApplication";
import {HeaderFooterApplicationFuso} from "./header_footer_application_fuso/HeaderFooterApplicationFuso";
import {DashboardTile} from "./dashboard_tile/DashboardTile";
import {HeaderFavorites} from "./header_favorites/HeaderFavorites";
import {NextStepNavigation} from "./next_step_navigation/NextStepNavigation";
import {NextStepNavigationDefault} from "./next_step_navigation_default/NextStepNavigationDefault";
import {Sticky} from "./sticky/Sticky";
import {JobStatusProgressBarDefault} from "./job_status/job_status_progress_bar_default/JobStatusProgressBarDefault";
import {JobStatusProgressBar} from "./job_status/job_status_progress_bar/JobStatusProgressBar";
import {JobStatusLogView} from "./job_status/job_status_log_view/JobStatusLogView";
import {JobStatusLogViewDefault} from "./job_status/job_status_log_view_default/JobStatusLogViewDefault";

import {ImageEditorModule} from "./image_editor_module/ImageEditorModule"
registerComponents({
    AbhAufUmbauarten,
    AbhVerkaufteEinheiten,
    Autocomplete,
    Breadcrumb,
    Button,
    ButtonLink,
    Calendar,
    // Carousel,
    // CarouselItemImg,
    Checkbox,
    CheckboxGroup,
    Col,
    Communication,
    CommunicationModule,
    ContentArea,
    Container,
    Cookie,
    FixedFooter,
    Fold,
    FoldIf,
    Footer,
    DashboardTile,
    Dropdown,
    Expander,
    FileInput,
    FilterBox,
    FilterItem,
    FilterBar,
    FilterBarItem,
    Form,
    GltState,
    Groupbox,
    H,
    HeadInfo,
    HeadInfoItem,
    Header,
    HeaderDefault,
    HeaderFavorites,
    HeaderFooterApplication,
    HeaderFooterApplicationFuso,
    DropdownOption,
    Icon,
    Input,
    InputGroup,
    InputList,
    InputListMultiple,
    Iris,
    JobStatusLogView,
    JobStatusLogViewDefault,
    JobStatusProgressBar,
    JobStatusProgressBarDefault,
    LightboxImg,
    Link,
    Loading,
    Message,
    Modal,
    ModalIframe,
    NavigationBar,
    NavigationBarItem,
    P,
    Pagination,
    PrivacyPolicy,
    ProcessBar,
    ProcessBarStep,
    ProgressBar,
    Radio,
    RadioGroup,
    Repeater,
    RichText,
    Row,
    Select,
    SelectGroup,
    SelectOption,
    Slider,
    SliderItemImg,
    Sticky,
    Table,
    TableCol,
    Tab,
    Tabs,
    TechdocSelectList,
    Textarea,
    Tile,
    TileGroup,
    Toggle,
    Tooltip,
    NextStepNavigation,
    NextStepNavigationDefault,
    ImageEditorModule
})